<template></template>
<script>
import proxy from "@pdfking/workflow/utils/proxy"

import { dismiss_dropdowns } from "../core/bootstrap"
import toggle_class from "../dom/toggle_class"
import navigate from "../routes/navigate"
import keyboard from "../state/keyboard"

export default {
  computed: proxy(keyboard, { ESCAPE: "escape_pressed" }),
  methods: {
    close() {
      navigate()
    },
  },
  mounted() {
    this.toggled_class
      ? toggle_class(document.body, { [this.toggled_class]: true })
      : null
  },
  unmounted() {
    this.toggled_class
      ? toggle_class(document.body, { [this.toggled_class]: false })
      : null
  },
  watch: {
    escape_pressed(v) {
      dismiss_dropdowns()
      this.close()
    },
  },
}
</script>
